module.exports = __webpack_public_path__ + "img/laethnobot-h-474x356.09fae710.jpg";